module.exports = __webpack_public_path__ + "static/media/loreal_logo.114a329c.webp";